import { useTheme } from '../theme'

/**
 * Segmented control HAUT — alternative a `BarreOnglets` pour les modules dont
 * les onglets sont peu nombreux et coiffes d'un contexte (S65).
 *
 * POURQUOI (retour Daniel, module Evenements client)
 * --------------------------------------------------
 * La barre basse d'un module se superpose visuellement a la barre basse du hub :
 * meme forme, meme place, mais l'une change de PAGE et l'autre d'ONGLET dans la
 * page. Avec seulement deux segments et un bandeau de contexte juste au-dessus,
 * un controle segmente colle sous l'en-tete dit ce qu'il est : une subdivision
 * du contenu, pas un changement de lieu. Il libere aussi le bas de l'ecran.
 *
 * `BarreOnglets` reste la norme pour le hub et pour les modules a trois onglets
 * (facette producteur) : ce composant ne la remplace pas, il la complete.
 *
 * `onglets` : [{ k, e (emoji), l (libelle), badge? }] · `actif` : cle active
 * · `onSelect(k)`.
 */
export default function OngletsHaut({ onglets, actif, onSelect }) {
  const { isWeb3 } = useTheme()
  return (
    // `sticky` : les onglets restent atteignables en defilant une longue liste
    // de produits, sans occuper le bas de l'ecran.
    // Le fond degrade evite que le contenu defile A NU derriere la pilule :
    // il s'estompe vers le bas, sans trancher avec le fond de page.
    <div
      className="sticky top-0 z-[30] -mx-4 px-4 pt-2 pb-3"
      style={{ background: 'linear-gradient(to bottom, var(--c-bg) 65%, transparent)' }}
    >
      <div
        role="tablist"
        className={`flex p-1 rounded-2xl ${isWeb3 ? 'bg-[#0a0a0f]/85 border border-white/10 backdrop-blur-xl' : 'glass-surface'}`}
      >
        {onglets.map((t) => {
          const active = actif === t.k
          return (
            <button
              key={t.k}
              role="tab"
              aria-selected={active}
              onClick={() => onSelect(t.k)}
              className={`relative flex-1 py-2 rounded-xl flex items-center justify-center gap-1.5 text-[13px] font-bold transition-all ${active ? 'text-creme' : 'text-ink/60'}`}
              style={active ? { background: 'rgb(var(--c-green))' } : undefined}
            >
              <span className="text-[15px] leading-none">{t.e}</span>
              {t.l}
              {t.badge > 0 && (
                <span
                  className="text-[9.5px] font-extrabold rounded-full px-1.5"
                  style={{ background: 'rgb(var(--c-primary))', color: 'rgb(var(--c-green))' }}
                >
                  {t.badge}
                </span>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
